/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as LoginRouteImport } from "./routes/login";
import { Route as ChangePasswordRouteImport } from "./routes/change-password";
import { Route as AppRouteImport } from "./routes/_app";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AppZonesRouteImport } from "./routes/_app/zones";
import { Route as AppVenueRouteImport } from "./routes/_app/venue";
import { Route as AppTablesRouteImport } from "./routes/_app/tables";
import { Route as AppStaffRouteImport } from "./routes/_app/staff";
import { Route as AppSocialRulesRouteImport } from "./routes/_app/social-rules";
import { Route as AppSessionsRouteImport } from "./routes/_app/sessions";
import { Route as AppScreenRouteImport } from "./routes/_app/screen";
import { Route as AppRolesRouteImport } from "./routes/_app/roles";
import { Route as AppQrRouteImport } from "./routes/_app/qr";
import { Route as AppMenuRouteImport } from "./routes/_app/menu";
import { Route as AppLayoutRouteImport } from "./routes/_app/layout";
import { Route as AppIncidentsRouteImport } from "./routes/_app/incidents";
import { Route as AppDashboardRouteImport } from "./routes/_app/dashboard";
import { Route as AppBranchesRouteImport } from "./routes/_app/branches";
import { Route as AppAnalyticsRouteImport } from "./routes/_app/analytics";
import { Route as AppSettingsRetentionRouteImport } from "./routes/_app/settings.retention";
import { Route as AppSettingsPrivacyRouteImport } from "./routes/_app/settings.privacy";
import { Route as AppMenuItemIdRouteImport } from "./routes/_app/menu.$itemId";

const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any);
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: "/change-password",
  path: "/change-password",
  getParentRoute: () => rootRouteImport,
} as any);
const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AppZonesRoute = AppZonesRouteImport.update({
  id: "/zones",
  path: "/zones",
  getParentRoute: () => AppRoute,
} as any);
const AppVenueRoute = AppVenueRouteImport.update({
  id: "/venue",
  path: "/venue",
  getParentRoute: () => AppRoute,
} as any);
const AppTablesRoute = AppTablesRouteImport.update({
  id: "/tables",
  path: "/tables",
  getParentRoute: () => AppRoute,
} as any);
const AppStaffRoute = AppStaffRouteImport.update({
  id: "/staff",
  path: "/staff",
  getParentRoute: () => AppRoute,
} as any);
const AppSocialRulesRoute = AppSocialRulesRouteImport.update({
  id: "/social-rules",
  path: "/social-rules",
  getParentRoute: () => AppRoute,
} as any);
const AppSessionsRoute = AppSessionsRouteImport.update({
  id: "/sessions",
  path: "/sessions",
  getParentRoute: () => AppRoute,
} as any);
const AppScreenRoute = AppScreenRouteImport.update({
  id: "/screen",
  path: "/screen",
  getParentRoute: () => AppRoute,
} as any);
const AppRolesRoute = AppRolesRouteImport.update({
  id: "/roles",
  path: "/roles",
  getParentRoute: () => AppRoute,
} as any);
const AppQrRoute = AppQrRouteImport.update({
  id: "/qr",
  path: "/qr",
  getParentRoute: () => AppRoute,
} as any);
const AppMenuRoute = AppMenuRouteImport.update({
  id: "/menu",
  path: "/menu",
  getParentRoute: () => AppRoute,
} as any);
const AppLayoutRoute = AppLayoutRouteImport.update({
  id: "/layout",
  path: "/layout",
  getParentRoute: () => AppRoute,
} as any);
const AppIncidentsRoute = AppIncidentsRouteImport.update({
  id: "/incidents",
  path: "/incidents",
  getParentRoute: () => AppRoute,
} as any);
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => AppRoute,
} as any);
const AppBranchesRoute = AppBranchesRouteImport.update({
  id: "/branches",
  path: "/branches",
  getParentRoute: () => AppRoute,
} as any);
const AppAnalyticsRoute = AppAnalyticsRouteImport.update({
  id: "/analytics",
  path: "/analytics",
  getParentRoute: () => AppRoute,
} as any);
const AppSettingsRetentionRoute = AppSettingsRetentionRouteImport.update({
  id: "/settings/retention",
  path: "/settings/retention",
  getParentRoute: () => AppRoute,
} as any);
const AppSettingsPrivacyRoute = AppSettingsPrivacyRouteImport.update({
  id: "/settings/privacy",
  path: "/settings/privacy",
  getParentRoute: () => AppRoute,
} as any);
const AppMenuItemIdRoute = AppMenuItemIdRouteImport.update({
  id: "/$itemId",
  path: "/$itemId",
  getParentRoute: () => AppMenuRoute,
} as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/change-password": typeof ChangePasswordRoute;
  "/login": typeof LoginRoute;
  "/analytics": typeof AppAnalyticsRoute;
  "/branches": typeof AppBranchesRoute;
  "/dashboard": typeof AppDashboardRoute;
  "/incidents": typeof AppIncidentsRoute;
  "/layout": typeof AppLayoutRoute;
  "/menu": typeof AppMenuRouteWithChildren;
  "/qr": typeof AppQrRoute;
  "/roles": typeof AppRolesRoute;
  "/screen": typeof AppScreenRoute;
  "/sessions": typeof AppSessionsRoute;
  "/social-rules": typeof AppSocialRulesRoute;
  "/staff": typeof AppStaffRoute;
  "/tables": typeof AppTablesRoute;
  "/venue": typeof AppVenueRoute;
  "/zones": typeof AppZonesRoute;
  "/menu/$itemId": typeof AppMenuItemIdRoute;
  "/settings/privacy": typeof AppSettingsPrivacyRoute;
  "/settings/retention": typeof AppSettingsRetentionRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/change-password": typeof ChangePasswordRoute;
  "/login": typeof LoginRoute;
  "/analytics": typeof AppAnalyticsRoute;
  "/branches": typeof AppBranchesRoute;
  "/dashboard": typeof AppDashboardRoute;
  "/incidents": typeof AppIncidentsRoute;
  "/layout": typeof AppLayoutRoute;
  "/menu": typeof AppMenuRouteWithChildren;
  "/qr": typeof AppQrRoute;
  "/roles": typeof AppRolesRoute;
  "/screen": typeof AppScreenRoute;
  "/sessions": typeof AppSessionsRoute;
  "/social-rules": typeof AppSocialRulesRoute;
  "/staff": typeof AppStaffRoute;
  "/tables": typeof AppTablesRoute;
  "/venue": typeof AppVenueRoute;
  "/zones": typeof AppZonesRoute;
  "/menu/$itemId": typeof AppMenuItemIdRoute;
  "/settings/privacy": typeof AppSettingsPrivacyRoute;
  "/settings/retention": typeof AppSettingsRetentionRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_app": typeof AppRouteWithChildren;
  "/change-password": typeof ChangePasswordRoute;
  "/login": typeof LoginRoute;
  "/_app/analytics": typeof AppAnalyticsRoute;
  "/_app/branches": typeof AppBranchesRoute;
  "/_app/dashboard": typeof AppDashboardRoute;
  "/_app/incidents": typeof AppIncidentsRoute;
  "/_app/layout": typeof AppLayoutRoute;
  "/_app/menu": typeof AppMenuRouteWithChildren;
  "/_app/qr": typeof AppQrRoute;
  "/_app/roles": typeof AppRolesRoute;
  "/_app/screen": typeof AppScreenRoute;
  "/_app/sessions": typeof AppSessionsRoute;
  "/_app/social-rules": typeof AppSocialRulesRoute;
  "/_app/staff": typeof AppStaffRoute;
  "/_app/tables": typeof AppTablesRoute;
  "/_app/venue": typeof AppVenueRoute;
  "/_app/zones": typeof AppZonesRoute;
  "/_app/menu/$itemId": typeof AppMenuItemIdRoute;
  "/_app/settings/privacy": typeof AppSettingsPrivacyRoute;
  "/_app/settings/retention": typeof AppSettingsRetentionRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/change-password"
    | "/login"
    | "/analytics"
    | "/branches"
    | "/dashboard"
    | "/incidents"
    | "/layout"
    | "/menu"
    | "/qr"
    | "/roles"
    | "/screen"
    | "/sessions"
    | "/social-rules"
    | "/staff"
    | "/tables"
    | "/venue"
    | "/zones"
    | "/menu/$itemId"
    | "/settings/privacy"
    | "/settings/retention";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/change-password"
    | "/login"
    | "/analytics"
    | "/branches"
    | "/dashboard"
    | "/incidents"
    | "/layout"
    | "/menu"
    | "/qr"
    | "/roles"
    | "/screen"
    | "/sessions"
    | "/social-rules"
    | "/staff"
    | "/tables"
    | "/venue"
    | "/zones"
    | "/menu/$itemId"
    | "/settings/privacy"
    | "/settings/retention";
  id:
    | "__root__"
    | "/"
    | "/_app"
    | "/change-password"
    | "/login"
    | "/_app/analytics"
    | "/_app/branches"
    | "/_app/dashboard"
    | "/_app/incidents"
    | "/_app/layout"
    | "/_app/menu"
    | "/_app/qr"
    | "/_app/roles"
    | "/_app/screen"
    | "/_app/sessions"
    | "/_app/social-rules"
    | "/_app/staff"
    | "/_app/tables"
    | "/_app/venue"
    | "/_app/zones"
    | "/_app/menu/$itemId"
    | "/_app/settings/privacy"
    | "/_app/settings/retention";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AppRoute: typeof AppRouteWithChildren;
  ChangePasswordRoute: typeof ChangePasswordRoute;
  LoginRoute: typeof LoginRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/change-password": {
      id: "/change-password";
      path: "/change-password";
      fullPath: "/change-password";
      preLoaderRoute: typeof ChangePasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app": {
      id: "/_app";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app/zones": {
      id: "/_app/zones";
      path: "/zones";
      fullPath: "/zones";
      preLoaderRoute: typeof AppZonesRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/venue": {
      id: "/_app/venue";
      path: "/venue";
      fullPath: "/venue";
      preLoaderRoute: typeof AppVenueRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/tables": {
      id: "/_app/tables";
      path: "/tables";
      fullPath: "/tables";
      preLoaderRoute: typeof AppTablesRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/staff": {
      id: "/_app/staff";
      path: "/staff";
      fullPath: "/staff";
      preLoaderRoute: typeof AppStaffRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/social-rules": {
      id: "/_app/social-rules";
      path: "/social-rules";
      fullPath: "/social-rules";
      preLoaderRoute: typeof AppSocialRulesRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/sessions": {
      id: "/_app/sessions";
      path: "/sessions";
      fullPath: "/sessions";
      preLoaderRoute: typeof AppSessionsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/screen": {
      id: "/_app/screen";
      path: "/screen";
      fullPath: "/screen";
      preLoaderRoute: typeof AppScreenRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/roles": {
      id: "/_app/roles";
      path: "/roles";
      fullPath: "/roles";
      preLoaderRoute: typeof AppRolesRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/qr": {
      id: "/_app/qr";
      path: "/qr";
      fullPath: "/qr";
      preLoaderRoute: typeof AppQrRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/menu": {
      id: "/_app/menu";
      path: "/menu";
      fullPath: "/menu";
      preLoaderRoute: typeof AppMenuRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/layout": {
      id: "/_app/layout";
      path: "/layout";
      fullPath: "/layout";
      preLoaderRoute: typeof AppLayoutRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/incidents": {
      id: "/_app/incidents";
      path: "/incidents";
      fullPath: "/incidents";
      preLoaderRoute: typeof AppIncidentsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/dashboard": {
      id: "/_app/dashboard";
      path: "/dashboard";
      fullPath: "/dashboard";
      preLoaderRoute: typeof AppDashboardRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/branches": {
      id: "/_app/branches";
      path: "/branches";
      fullPath: "/branches";
      preLoaderRoute: typeof AppBranchesRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/analytics": {
      id: "/_app/analytics";
      path: "/analytics";
      fullPath: "/analytics";
      preLoaderRoute: typeof AppAnalyticsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/settings/retention": {
      id: "/_app/settings/retention";
      path: "/settings/retention";
      fullPath: "/settings/retention";
      preLoaderRoute: typeof AppSettingsRetentionRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/settings/privacy": {
      id: "/_app/settings/privacy";
      path: "/settings/privacy";
      fullPath: "/settings/privacy";
      preLoaderRoute: typeof AppSettingsPrivacyRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/menu/$itemId": {
      id: "/_app/menu/$itemId";
      path: "/$itemId";
      fullPath: "/menu/$itemId";
      preLoaderRoute: typeof AppMenuItemIdRouteImport;
      parentRoute: typeof AppMenuRoute;
    };
  }
}

interface AppMenuRouteChildren {
  AppMenuItemIdRoute: typeof AppMenuItemIdRoute;
}

const AppMenuRouteChildren: AppMenuRouteChildren = {
  AppMenuItemIdRoute: AppMenuItemIdRoute,
};

const AppMenuRouteWithChildren =
  AppMenuRoute._addFileChildren(AppMenuRouteChildren);

interface AppRouteChildren {
  AppAnalyticsRoute: typeof AppAnalyticsRoute;
  AppBranchesRoute: typeof AppBranchesRoute;
  AppDashboardRoute: typeof AppDashboardRoute;
  AppIncidentsRoute: typeof AppIncidentsRoute;
  AppLayoutRoute: typeof AppLayoutRoute;
  AppMenuRoute: typeof AppMenuRouteWithChildren;
  AppQrRoute: typeof AppQrRoute;
  AppRolesRoute: typeof AppRolesRoute;
  AppScreenRoute: typeof AppScreenRoute;
  AppSessionsRoute: typeof AppSessionsRoute;
  AppSocialRulesRoute: typeof AppSocialRulesRoute;
  AppStaffRoute: typeof AppStaffRoute;
  AppTablesRoute: typeof AppTablesRoute;
  AppVenueRoute: typeof AppVenueRoute;
  AppZonesRoute: typeof AppZonesRoute;
  AppSettingsPrivacyRoute: typeof AppSettingsPrivacyRoute;
  AppSettingsRetentionRoute: typeof AppSettingsRetentionRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppAnalyticsRoute: AppAnalyticsRoute,
  AppBranchesRoute: AppBranchesRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppIncidentsRoute: AppIncidentsRoute,
  AppLayoutRoute: AppLayoutRoute,
  AppMenuRoute: AppMenuRouteWithChildren,
  AppQrRoute: AppQrRoute,
  AppRolesRoute: AppRolesRoute,
  AppScreenRoute: AppScreenRoute,
  AppSessionsRoute: AppSessionsRoute,
  AppSocialRulesRoute: AppSocialRulesRoute,
  AppStaffRoute: AppStaffRoute,
  AppTablesRoute: AppTablesRoute,
  AppVenueRoute: AppVenueRoute,
  AppZonesRoute: AppZonesRoute,
  AppSettingsPrivacyRoute: AppSettingsPrivacyRoute,
  AppSettingsRetentionRoute: AppSettingsRetentionRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  LoginRoute: LoginRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
